import type { IAudit } from '@ifs-gcp/core';
import type { QuestionChild } from '@ifs-gcp/core/models';

import { getTranslation } from '../../../utils/translations';

export const getPlaceholderValue = (
  placeholder: QuestionChild['props']['placeholder'],
  language: string,
  conditions: IAudit['conditions'],
) => {
  if (Array.isArray(placeholder)) {
    return getTranslation(
      placeholder.find(({ visibilityCondition }) => conditions.validate(visibilityCondition))?.text,
      language,
    );
  }

  if (typeof placeholder === 'object') {
    /**
     * This whole check might not be needed, as we do not have visibilitycondition in placeholders anymore
     * If no definitions are found with this, let's remove it
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return getTranslation(placeholder, language);
  }

  return undefined;
};
